module.exports = __webpack_public_path__ + "images/application/email-blue-46f23316.svg";